var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_652)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1055 6.21094C18.7734 5.80078 19.2188 5.05664 19.2188 4.21875C19.2188 2.92383 18.1699 1.875 16.875 1.875C15.5801 1.875 14.5312 2.92383 14.5312 4.21875C14.5312 5.0625 14.9766 5.80078 15.6445 6.21094L12.2871 12.9258C11.7539 13.9922 10.3711 14.2969 9.43945 13.5527L4.21875 9.375C4.51172 8.98242 4.6875 8.49609 4.6875 7.96875C4.6875 6.67383 3.63867 5.625 2.34375 5.625C1.04883 5.625 0 6.67383 0 7.96875C0 9.26367 1.04883 10.3125 2.34375 10.3125C2.35547 10.3125 2.37305 10.3125 2.38477 10.3125L5.0625 25.043C5.38477 26.8242 6.9375 28.125 8.75391 28.125H24.9961C26.8066 28.125 28.3594 26.8301 28.6875 25.043L31.3652 10.3125C31.377 10.3125 31.3945 10.3125 31.4062 10.3125C32.7012 10.3125 33.75 9.26367 33.75 7.96875C33.75 6.67383 32.7012 5.625 31.4062 5.625C30.1113 5.625 29.0625 6.67383 29.0625 7.96875C29.0625 8.49609 29.2383 8.98242 29.5312 9.375L24.3105 13.5527C23.3789 14.2969 21.9961 13.9922 21.4629 12.9258L18.1055 6.21094Z",
    fill: "#EA580C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_652"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H33.75V30H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.91158f63628af634a58ce1cd0d0e7182.svg";
export { ForwardRef as ReactComponent };